import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-text.tsx
/**
* icon.16.text
*
* Keywords: typography, letter, t, font, typeface, character, serif, formatting
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMyAzLjVhLjUuNSAwIDAgMSAuNS0uNWg5YS41LjUgMCAwIDEgLjUuNVY1YS41LjUgMCAwIDEtMSAwVjRIOC41djhoMWEuNS41IDAgMCAxIDAgMWgtM2EuNS41IDAgMCAxIDAtMWgxVjRINHYxYS41LjUgMCAwIDEtMSAweiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-12443
*/
const Icon16Text = memo(function Icon16Text(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-1 0V4H8.5v8h1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h1V4H4v1a.5.5 0 0 1-1 0z",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M3 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V4H8v7h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H7V4H4v.5a.5.5 0 0 1-1 0z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Text };

//# sourceMappingURL=icon-16-text.js.map